module.exports = __webpack_public_path__ + "img/1-certifications-fs_in-person.png";